export const formatCurrency = (amount?: number) => {
  if (amount === null || amount === undefined) return '' // Check for null or undefined

  // Convert to string
  const amountStr = amount.toString()

  // Pad with zeros if necessary to ensure at least two digits are after the decimal point
  const paddedAmount = amountStr.padStart(3, '0')

  // Insert decimal point before the last two digits
  let formattedAmount = paddedAmount.slice(0, -2) + '.' + paddedAmount.slice(-2)

  // If the cents are "00", remove them from the string
  if (formattedAmount.endsWith('.00')) {
    formattedAmount = formattedAmount.substring(0, formattedAmount.length - 3)
  }

  return formattedAmount
}
